'use es6';

import { postAllAvailability as postAllAvailabilityRequest } from 'MeetingsLib/api/availabilityAPI';
export const postAllAvailability = data => (dispatch, getState, httpClient) => postAllAvailabilityRequest(httpClient, data);